var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "data-om-id": "jsx:/https:/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89.claudeusercontent.com/v1/design/projects/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89/serve/sidebar.jsx:1560:22:5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 5,
    r: 3,
    "data-om-id": "jsx:/https:/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89.claudeusercontent.com/v1/design/projects/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89/serve/sidebar.jsx:1703:22:148"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 3,
    "data-om-id": "jsx:/https:/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89.claudeusercontent.com/v1/design/projects/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89/serve/sidebar.jsx:1733:22:178"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 3,
    "data-om-id": "jsx:/https:/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89.claudeusercontent.com/v1/design/projects/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89/serve/sidebar.jsx:1763:22:208"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.59 13.51 6.83 3.98M15.41 6.51l-6.82 3.98",
    "data-om-id": "jsx:/https:/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89.claudeusercontent.com/v1/design/projects/019e08cf-8d3c-7a2f-8d6b-e1b72fd43e89/serve/sidebar.jsx:1794:22:239"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.495c13c5776382ac64b0e744cf55bcee.svg";
export { ForwardRef as ReactComponent };